import { render, staticRenderFns } from "./AssignmentsModal.vue?vue&type=template&id=03bfb0a8&"
import script from "./AssignmentsModal.vue?vue&type=script&lang=js&"
export * from "./AssignmentsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports